"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MessageEmptyImage = void 0;
var React = _interopRequireWildcard(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const MessageEmptyImage = () => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  width: "140",
  height: "140",
  viewBox: "0 0 140 140",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M69.9997 120C97.613 120 120 97.6572 120 69.9998C120 42.3424 97.613 20 69.9997 20C42.3865 20 20 42.3424 20 69.9998C20 97.6572 42.3865 120 69.9997 120Z",
    fill: "#E6E5EF"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M121.556 53.3176C123.82 53.3176 125.656 51.4819 125.656 49.2176C125.656 46.9532 123.82 45.1176 121.556 45.1176C119.291 45.1176 117.456 46.9532 117.456 49.2176C117.456 51.4819 119.291 53.3176 121.556 53.3176Z",
    fill: "#9F9FBC"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M127.556 37.2176C129.102 37.2176 130.356 35.964 130.356 34.4176C130.356 32.8712 129.102 31.6176 127.556 31.6176C126.009 31.6176 124.756 32.8712 124.756 34.4176C124.756 35.964 126.009 37.2176 127.556 37.2176Z",
    fill: "#9F9FBC"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M82.4554 39.8607C99.7181 39.8607 113.643 52.4152 113.643 67.8491C113.643 76.7178 109.04 84.6651 101.79 89.8481V101.481C101.79 103.094 99.9482 103.9 98.7974 102.979L88.9001 95.2615C86.8286 95.6071 84.7571 95.8374 82.5705 95.8374C65.3078 95.8374 51.3826 83.283 51.3826 67.8491C51.3826 52.4152 65.3078 39.8607 82.4554 39.8607Z",
    fill: "#FAFAFA",
    stroke: "#D3D2E0",
    strokeWidth: "2",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M51.9581 38.4785C32.739 38.4785 17.2026 52.4151 17.2026 69.5767C17.2026 79.482 22.3814 88.3507 30.4373 93.9945V106.895C30.4373 108.622 32.3938 109.659 33.7748 108.507L44.8229 99.9838C47.1246 100.445 49.4263 100.675 51.843 100.675C71.0621 100.675 86.5985 86.7383 86.5985 69.5767C86.5985 52.4151 71.0621 38.4785 51.9581 38.4785Z",
    fill: "white",
    stroke: "#D3D2E0",
    strokeWidth: "2",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M40.6223 70.8437C42.7197 70.8437 44.4201 69.142 44.4201 67.0428C44.4201 64.9437 42.7197 63.2419 40.6223 63.2419C38.5248 63.2419 36.8245 64.9437 36.8245 67.0428C36.8245 69.142 38.5248 70.8437 40.6223 70.8437Z",
    fill: "#66658D"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M62.143 70.8437C64.2405 70.8437 65.9408 69.142 65.9408 67.0428C65.9408 64.9437 64.2405 63.2419 62.143 63.2419C60.0455 63.2419 58.3452 64.9437 58.3452 67.0428C58.3452 69.142 60.0455 70.8437 62.143 70.8437Z",
    fill: "#66658D"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M43.3971 35.5555C43.2584 35.5555 43.1196 35.5555 42.9808 35.5555C42.287 35.2777 41.8707 34.5834 42.0095 33.889L44.3685 26.2508C44.646 25.5564 45.3398 25.1398 46.0336 25.2787C46.7274 25.5564 47.1437 26.2508 47.005 26.9452L44.7848 34.5834C44.646 35.1389 44.0909 35.5555 43.3971 35.5555Z",
    fill: "#66658D"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M37.5689 37.222C37.0139 37.222 36.4588 36.8054 36.1813 36.2499L32.5735 25.2787C32.2959 24.5844 32.7122 23.7511 33.406 23.4734C34.0999 23.1956 34.9324 23.6122 35.2099 24.3066L38.8178 35.2778C39.0953 35.9722 38.679 36.8054 37.9852 37.0832C37.8464 37.222 37.7077 37.222 37.5689 37.222Z",
    fill: "#66658D"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M32.1574 39.8607C31.7411 39.8607 31.4636 39.7219 31.186 39.4441L26.7456 35.139C26.1906 34.5835 26.1906 33.7502 26.7456 33.1947C27.3007 32.6392 28.1333 32.6392 28.6883 33.1947L33.1287 37.4998C33.6838 38.0554 33.6838 38.8886 33.1287 39.4441C32.8512 39.7219 32.4349 39.8607 32.1574 39.8607Z",
    fill: "#66658D"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M47 77L57 77",
    stroke: "#66658D",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
});
exports.MessageEmptyImage = MessageEmptyImage;